import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  container: {
    padding: 8
  },
  select: {
    display: 'flex',
    padding: 10,
    borderRadius: 6,
    cursor: 'pointer',
    '&:hover': {
      background: '#f7f7f8'
    }
  },
  label: {
    marginLeft: 10,
    fontSize: 14,
    fontWeight: 400
  },
  sectionTitle: {
    color: '#6A728F',
    fontSize: 12,
    marginTop: 4,
    marginLeft: 12,
    marginBottom: 10
  }
}));

export type Option = {
  label: string;
  type: 'checkbox';
  checked?: boolean;
  value?: string;
};

export type FilterOptionsState = { [key: string]: Option };

type Props = {
  onChange?: (options: FilterOptionsState) => void;
  options: FilterOptionsState;
  title?: string;
};

export default function FilterOptions({ options, onChange, title }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {title && <div className={classes.sectionTitle}>{title}</div>}

      {Object.entries(options).map(([name, option], index) => (
        <div
          key={option.label}
          className={classes.select}
          onClick={() => {
            onChange &&
              onChange({
                ...options,
                [name]: {
                  ...option,
                  checked: !option.checked
                }
              });
          }}
        >
          <input type="checkbox" defaultChecked={option.checked} />
          <div className={classes.label}>{option.label}</div>
        </div>
      ))}
    </div>
  );
}
